import React, {Component} from 'react'
import './main.css'
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import axios from 'axios';

class Main extends Component {
    state = {
        name: '',
        email: '',
        message: ''
      }
      handleSubmit(e){
        e.preventDefault();
        axios({
          method: "POST",
          url:"http://localhost:3002/send",
          data:  this.state
        }).then((response)=>{
          if (response.data.status === 'success') {
            alert("Message Sent.");
            this.resetForm()
          } else if (response.data.status === 'fail') {
            alert("Message failed to send.")
          }
        })
      }
    
      resetForm(){
        this.setState({name: "", email: "", message: ""})
      }
    
  render() {
    //const lang = localStorage.getItem('lang') || 'en';
    return (
        <>
           <div  className='head'>
              <div className='logo'>
                <img src="logo_paysage.2aa4fa8c.png" alt='' />
              </div>
              <div className="textCardre">
              <Popup
                  trigger={<button className="button"><span className="txtcadre"> DEMANDEZ VOTRE COTATION GRATUITE </span></button>}
                 modal
                  nested
            >
    {close => (
      <div className="modal">
        <button className="close" onClick={close}>
          &times;
        </button>
        <div className="header"> Formulaire demande de Cotation </div>
        <div className="content">
          {' '}
          <form id="contact-form" onSubmit={this.handleSubmit.bind(this)} method="POST">
          <div className="form-group">
              <label htmlFor="name">Name</label>
              <input placeholder="Your Name........." type="text" className="form-control" id="name" value={this.state.name} onChange={this.onNameChange.bind(this)} />
          </div>
          <div className="form-group">
              <label htmlFor="exampleInputEmail1">Email address</label>
              <input placeholder="Your Email..........." type="email" className="form-control" id="email" aria-describedby="emailHelp" value={this.state.email} onChange={this.onEmailChange.bind(this)} />
          </div>
          <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea placeholder="Your Message......" className="form-control" rows="5" id="message" value={this.state.message} onChange={this.onMessageChange.bind(this)} />
          </div>
         
          <input type="submit" value="Submit" className="button" />
        
        </form>
        </div>
      </div>
    )}
  </Popup>
              </div>
              <div className="ad">
                  <a href="#home"><img src='linkedin-nouveau.svg' alt='twitter'/></a>
                   <a href="#home"><img src='facebook-nouveau.svg' alt='facebook'/></a>
                    <a href="#home"><img src='instagram-nouveau.svg' alt='instagram'/></a>
                    <a href="#home"><img src='twitter-nouveau2.svg' alt='twitter'/></a>
                    
                </div>
           </div>
        </>
    )
  }
  onNameChange(event) {
    this.setState({name: event.target.value})
}

onEmailChange(event) {
    this.setState({email: event.target.value})
}

onMessageChange(event) {
    this.setState({message: event.target.value})
}
}

export default Main;
